import { IBackgroundService } from '../../interfaces';
import { injectable } from 'inversify';

@injectable()
export class SoundNotificationsMock implements IBackgroundService {
    start(): void {
        throw new Error('Method not implemented.');
    }
}
